import { useMemo } from 'react'
import { Accordion } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import Link from 'components/Link'
import { chapterPath } from 'libs/paths'
import { ClassSpecialTypes } from '../../classSpecialType'
import { trackPlaylistModule } from './events'
import { getEpisodeListFromCourse } from './utils'
import styles from './Details.module.scss'

const EpisodeList = () => {
  const { course, classSpecialType } = useStaticData()
  const { t } = useTranslation('@mc/next')

  const allChapters = useMemo(() => getEpisodeListFromCourse(course), [course])
  // Continuous-cut
  const hasSubchapters = useMemo(
    () => course.sortedSubchapters?.length,
    [course],
  )

  const trackPlaylistModuleClick = ([chapterId]) => {
    const chapter = course.sortedChapters.find((ch) => `${ch.id}` === chapterId)
    if (chapter) {
      trackPlaylistModule(chapter)
    }
  }

  let episodeListTitle = hasSubchapters
    ? t('course.details.chapters.titleCC')
    : t('course.details.chapters.title')

  if (classSpecialType === ClassSpecialTypes.DOCUMENTARY) {
    episodeListTitle = t('documentary.details.chapters.title')
  }

  return (
    <>
      <h3 className='mc-text-h7 mc-mt-4 mc-mb-2'>{episodeListTitle}</h3>

      <div className={`${styles.scrollOuter} flex-grow-1`}>
        <div className={styles.scrollInner}>
          {hasSubchapters ? (
            <ol>
              {allChapters.map((subchapter, index) => (
                <li
                  key={subchapter.id}
                  className={`mc-p-4 mc-bg-neutral-900 mc-corners--1 mc-mb-1 mc-text--1-line ${styles.title}`}
                >
                  {`${index + 1}. ${subchapter.title}`}
                </li>
              ))}
            </ol>
          ) : (
            <Accordion onChange={trackPlaylistModuleClick}>
              {allChapters.map((chapter) => (
                <Accordion.Item
                  key={chapter.id}
                  uuid={`${chapter.id}`}
                  label={
                    <h4 className='mc-text--1-line mc-mr-5'>
                      {`${chapter.number ? `${chapter.number}. ` : ''}${
                        chapter.title
                      }`}
                    </h4>
                  }
                >
                  <p className='mc-mb-2'>{chapter.duration}</p>
                  <p className='mc-mb-2'>{chapter.abstract}</p>
                  <Link
                    isBasic
                    href={chapterPath(course.slug, chapter.slug)}
                    className='mc-text--link'
                    passHref
                  >
                    {t('course.details.chapters.readMore')}
                  </Link>
                </Accordion.Item>
              ))}
            </Accordion>
          )}
        </div>
      </div>
    </>
  )
}

export default EpisodeList
